<!--
 * @Description: 
 * @Author: 诺
 * @Date: 2021-12-19 17:08:44
 * @LastEditors: 诺
 * @LastEditTime: 2022-03-09 14:53:03
-->
<template>
  <div>
    <div class="podium" v-if="ranking.length!=0">
      <div class="second item" >
        <div class="avatarUrl">
          <template v-if="ranking.length >= 2">
            <img class="userImg" :src="ranking[1].headImgUrl" />
            <img
              class="rank"
              src="https://assets.rurushishi.com/activies/activityCenter/turntableLottery/rank2.png"
            />
          </template>
        </div>
        <div class="base">
          <div
            class="noodles"
          ></div>
          <div ref="second" class="baseBox" :style="bgStyle">
            <template v-if="ranking.length >= 2">
              <div class="userName">{{ ranking[1].nickname }}</div>
              <div class="count">{{ ranking[1].count }}</div>
              <div class="tip">{{helpText}}</div>
            </template>
          </div>
          <!-- :style="{
                backgroundImage: `linear-gradient(180deg, #B70110 0%, #B7011000 100%);`,
              }" -->
        </div>
      </div>
      <div class="first item" >
        <div class="avatarUrl">
          <template v-if="ranking.length >= 1">
            <img class="userImg" :src="ranking[0].headImgUrl" />
            <img
              class="rank"
              src="https://assets.rurushishi.com/activies/activityCenter/turntableLottery/rank1.png"
            />
          </template>
        </div>
        <div class="base">
          <div
            class="noodles"
          ></div>
          <div ref="first" class="baseBox" :style="bgStyle">
            <template v-if="ranking.length >= 1">
              <div class="userName">{{ ranking[0].nickname }}</div>
              <div class="count">{{ ranking[0].count }}</div>
              <div class="tip">{{helpText}}</div>
            </template>
          </div>
          <!-- :style="{
                backgroundImage: `linear-gradient(180deg, #B70110 0%, #B7011000 100%);`,
              }" -->
        </div>
      </div>
      <div class="third item" >
        <div class="avatarUrl">
          <template v-if="ranking.length >= 3">
            <img class="userImg" :src="ranking[2].headImgUrl" />
            <img
              class="rank"
              src="https://assets.rurushishi.com/activies/activityCenter/turntableLottery/rank3.png"
            />
          </template>
        </div>
        <div class="base">
          <div
            class="noodles"
          ></div>
          <div ref="third" class="baseBox" :style="bgStyle">
            <template v-if="ranking.length >= 3">
              <div class="userName">{{ ranking[2].nickname }}</div>
              <div class="count">{{ ranking[2].count }}</div>
              <div class="tip">{{helpText}}</div>
            </template>
          </div>
          <!-- :style="{
                backgroundImage: `linear-gradient(180deg, #B70110 0%, #B7011000 100%);`,
              }" -->
        </div>
      </div>
    </div>
    <div class="model" v-if="ranking.length>3" :style="{ borderColor: bColor }">
      <div
        class="modelTitle"
        :style="{ backgroundColor: bColor, color: textColor }"
      >
      {{ title }}
      </div>
      <div class="modelBg">
        <div class="list">
          <div
            class="item"
            v-for="(item, index) in ranking"
            :key="index"
            v-if="index >= 3"
          >
            <div class="rank">{{ index + 1 }}</div>
            <img class="userImg" :src="item.headImgUrl" />
            <div class="userName">{{ item.nickname }}</div>
            <div class="num">{{ item.count }}</div>
            <div class="icon">
              <img
                class="iconImg"
                src="https://assets.rurushishi.com/activies/activityCenter/assistanceHelp/vector.png"
              />
              <span>{{helpText}}</span>
            </div>
          </div>

          <div class="more" v-if="showMore" @click="clickMore" :style="{color: bColor,borderColor:bColor }">
            查看前50名
            <div class="jt" :style="{ backgroundColor: bColor }"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["data", "bColor", "bgColor", "title", "textColor",'helpText'],
  data() {
    return { ranking: [] ,showMore:false};
  },
  created() {},
  methods: {
    clickMore(){
      this.ranking=this.data
      this.showMore=false
    },
  },
  computed: {
    bgStyle(){
      return {
        background: `linear-gradient(180deg, ${this.bgColor} 0%, ${this.bgColor}00 100%)`,
      }
    },
  },
  watch: {
    // bgColor: {
    //   handler(val) {
    //     this.$nextTick(() => {
    //       let name = ["first", "second", "third"];
    //       name.map((item) => {
    //         this.$refs[
    //           item
    //         ].style = `background: linear-gradient(180deg, ${val} 0%, ${val}00 100%);`;
    //       });
    //     });
    //   },
    //   deep: true,
    // },
    data:{
       handler(val) {
        this.$nextTick(() => {
         this.ranking=val.slice(0,10)
         if(val.length>10){
           this.showMore=true
         }
        });
      },
      deep: true,
    }
  },
};
</script>
<style lang="stylus" scoped>
div {
  position: relative;
  box-sizing: border-box;

  img {
    width: 100%;
  }
}

    .podium {
      display: flex;
      margin: 30px auto 0;
      justify-content: center;

      .item {
        width: 129px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .avatarUrl {
          position: relative;
          width: 66px;
          height: 66px;
          z-index: 1;

          .userImg {
            border-radius: 50%;
            width: 100%;
            height: 100%;
            border: 2px solid #fff;
            box-sizing: border-box;
          }

          .rank {
            position: absolute;
            top: 42px;
            left: 44px;
            width: 24px;
          }
        }

        .base {
          width: 100%;
          margin-top: -15px;

          .noodles {
            width: 100%;
            border-bottom:20px solid rgba(255, 255, 255, 0.5);;
            border-left: 25px solid transparent;
            border-right: 25px solid transparent;
          }

          .baseBox {
            width: 100%;
            height: 108px;
            padding: 0 10px;
            

            .userName {
              font-weight: 500;
              font-size: 14px;
              line-height: 22px;
              text-align: center;
              color: #FFFFFF;
              padding-top: 6px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .count {
              font-family: DIN Alternate;
              font-weight: normal;
              font-size: 32px;
              line-height: 24px;
              text-align: center;
              color: #FFFFFF;
              margin-top: 10px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .tip {
              font-size: 10px;
              line-height: 10px;
              text-align: center;
              color: #FFFFFF;
              margin-top: 6px;
            }
          }
        }
      }

      .second {
        width: 105px;
        margin-top: 50px;

        .avatarUrl {
          width: 48px;
          height: 48px;

          .rank {
            top: 25px;
            left: 28px;
          }
        }

        .base .baseBox .count {
          font-size: 24px;
        }
         .baseBox{
           height:88px!important;
         }

        .noodles {
          border-right: none !important;
        }
      }

      .third {
        width: 105px;
        margin-top: 50px;

        .avatarUrl {
          width: 48px;
          height: 48px;

          .rank {
            top: 25px;
            left: 28px;
          }
        }

        .base .baseBox .count {
          font-size: 24px;
        }
         .baseBox{
           height:88px!important;
         }

        .noodles {
          border-left: none !important;
        }
      }
    }
.model {
  width: 351px;
  margin: 50px auto 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 12px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
  border: 5px solid;
  box-sizing: border-box;

  .modelTitle {
    position: absolute;
    margin-top: -20px;
    color: white;
    padding: 0 20px;
    line-height: 40px;
    height: 40px;
    text-align: center;
    border-radius: 6px;
    display: inline-block;
    font-size: 20px;
    font-weight: 600;
    z-index: 1;
  }

  .modelBg {
    width: 100%;
    background-color: rgba(255, 255, 255, 0.9);
    border-radius: 7px;

    .list {
      height: 100%;
      padding-top:24px;
      margin-bottom: 24px;

      .item {
        width: 100%;
        display: flex;
        height: 64px;
        align-items: center;
        justify-content: space-between;
        border-bottom: 0.5px solid rgba(239, 19, 80, 0.2);

        .rank {
          width: 24px;
          height: 24px;
          font-weight: bold;
          font-size: 18px;
          line-height: 24px;
          text-align: center;
          color: #617086;
        }

        .userImg {
          width: 32px;
          height: 32px;
          border-radius: 16px;
        }

        .userName {
          flex: 1;
          padding: 0 16px;
          font-weight: normal;
          font-size: 16px;
          line-height: 24px;
          color: #000000;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .num {
          font-weight: bold;
          font-size: 24px;
          line-height: 24px;
          text-align: center;
          color: #262626;
        }

        .icon {
          width: 40px;
          display: flex;
          flex-direction: column;
          align-items: center;
          font-weight: 500;
          font-size: 9px;
          line-height: 10px;
          color: #EF1350;
          margin-left: 10px;

          .iconImg {
            width: 16px;
            height: 16px;
            margin-bottom: 5px;
          }
        }
      }

      .item:last-child {
        border-bottom: none;
      }

      .more{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 8px 12px 8px 20px;
        width: 127px;
        height: 32px;
        border-radius: 20px;
        border:1px solid ;
        font-size: 14px;
        line-height: 16px;
        margin:16px auto 0;
        .jt {
          clip-path: polygon(0% 0, 100% 0%, 50% 100%);
          transition: 1s clip-path;
          width: 7px;
          height: 4px;
          margin-left:12px;
        }
      }
    }
  }
}
</style>
